import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers } from "../module_auth/AuthService"
import parse from 'html-react-parser';
import {
    BrowserRouter as Router,
    useParams,
  } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export function JobHome() {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")

    //채용상세
    const [objTitle, setObjTitle] = useState("");

    const [cpName, setCpName] = useState("");
    const [cpAddress, setCpAddress] = useState("");
    const [fullname, setFullname] = useState("");
    const [telno, setTelno] = useState("");
    const [email, setEmail] = useState("");
    
    const [regJob, setRegJob] = useState("");
    const [workCity, setWorkCity] = useState("0");
    const [workTime, setWorkTime] = useState("0");

    const [visaCond, setVisaCond] = useState("");
    const [applyCond, setApplyCond] = useState("");

    const [cpIntro, setCpIntro] = useState("");
    const [jobDetail, setJobDetail] = useState("");
    //End 채용상세

    useEffect(() => {
        let url = basePort + '/get/job/' + id
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
                //...
                setObjTitle(response.objTitle)
                setCpName(response.cpName)
                setJobDetail(response.jobDetail)
                
          }).catch(error => console.log(error))
    }, []);

    let navigate = useNavigate();    
    function backToList() {
        let url = "/home";
        navigate(url);
    }

    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>채용정보</span></li>
                            <li class="breadcrumb-item"><span>채용상세</span></li>
                        </ol>
                        <div class="card">
                        <div class="card-body" style={{marginBottom: '10px'}}>
                            <h4 class="card-title" style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>이번에 오픈하는 가게 인테리어</h4>
                            <p class="card-text" style={{fontWeight: 'bold', marginTop: '10px', fontFamily: 'Nanum Gothic'}}>회사정보</p>
                            <ul class="list-group">
                                <li class="list-group-item"><span>회사명: {cpName}</span></li>
                                <li class="list-group-item"><span>회사주소:</span></li>
                                <li class="list-group-item"><span>채용담당자:</span></li>
                                <li class="list-group-item"><span>연락처:</span></li>
                                <li class="list-group-item"><span>이메일:</span></li>
                            </ul>
                            <p class="card-text" style={{fontWeight: 'bold', marginTop: '10px', fontFamily: 'Nanum Gothic'}}>근무조건</p>
                            <ul class="list-group">
                                <li class="list-group-item"><span>모집부문:</span></li>
                                <li class="list-group-item"><span>근무도시:</span></li>
                                <li class="list-group-item"><span>근무형태:</span></li>
                                <li class="list-group-item"><span>비자조건:</span></li>
                                <li class="list-group-item"><span>지원조건:</span></li>
                            </ul>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title" style={{fontSize: '20px', fontDamily: 'Nanum Gothic', fontWeight: 'bold'}}>회사소개</h4>
                            <p class="card-text"><span style={{color: '#434343'}}>풀타임/ 파타임 일반 청소 보조하실 남자분 구합니다</span><br/><span style={{color: '#434343'}}>최소 경력 1 년이상이신분 우대 해드립니다.</span><br/><br/><span style={{color: '#434343'}}>주 업무는 홈, 오피스, 이니셜, 무빙 등입니다</span><br/><span style={{color: '#434343'}}>월-토요일 근무 평균 30 - 40 시간 근무합니다</span><br/><span style={{color: '#434343'}}>주 평균 $800 - $1200 보장</span><br/><br/><span style={{color: '#434343'}}>디파짓 없이 매주 페이 됩니다</span><br/><span style={{color: '#434343'}}>회사 차량 및 장비 제공 됩니다</span><br/><br/><br/><span style={{color: '#434343'}}>간단한 자기 소개서 는 아래 연락처로 문자 나 이메일 보내주세요</span><br/><span style={{color: '#434343'}}>바로 시작 가능합니다</span></p>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title" style={{fontSize: '20px', fontDamily: 'Nanum Gothic', fontWeight: 'bold'}}>모집상세</h4>
                                {parse(jobDetail)}
                        </div>
                    </div>
                </div>
                <nav class="d-flex d-md-flex justify-content-center justify-content-md-center" style={{margintop: '10px'}}>
                    <ul class="pagination">
                        <li class="page-item"><a class="page-link" onClick={backToList}>목록</a></li>
                    </ul>
                </nav>
                </section>
            </main>
        </div>
    );
}